import { ObservableWrapperService } from '../services/observable-wrapper.service';
import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiResult } from './api-result';

declare const ___baseUrl: string;

export abstract class DataRepository {
    protected abstract http: HttpClient;
    protected abstract api: string;

    public constructor(public ow: ObservableWrapperService) { }

    protected jsonToFormData(json: any): string {
        const isObject = ($o: any) => typeof $o === 'object' && $o !== null;

        const isFunction = ($o: any) => typeof $o === 'function';

        const leadingZeros = (number: number, maxLength: number): string =>
            number.toString().padStart(maxLength, '0');

        const visit = ($json: any, $arr?: any, $prefix?: any) => {
            let t0: any;
            let i: any;
            let j = '';
            t0 = $arr || [];
            $prefix = $prefix || '';
            for (i in $json) {
                if (i.startsWith('_')) {
                    continue;
                } else if (isFunction($json[i])) {
                    continue;
                } else if (Array.isArray($json[i])) {
                    for (j in $json[i]) {
                        if (isFunction($json[i][j])) {
                            continue;
                        }

                        if (isObject($json[i][j])) {
                            t0.concat(
                                visit(
                                    $json[i][j],
                                    t0,
                                    ($prefix ? $prefix + '.' : '') +
                                    i +
                                    '[' +
                                    j +
                                    ']'
                                )
                            );
                        } else {
                            t0.push(
                                ($prefix ? $prefix + '.' : '') +
                                i +
                                '[' +
                                j +
                                ']' +
                                '=' +
                                (typeof $json[i][j] !== 'undefined' &&
                                    $json[i][j] !== null
                                    ? encodeURIComponent($json[i][j])
                                    : '')
                            );
                        }
                    }
                    $prefix = $prefix || '';
                    continue;
                } else if (
                    isObject($json[i]) &&
                    ($json[i]['toDate'] != null ||
                        $json[i]['getUTCDate'] != null)
                ) {
                    if ($json[i]['toDate']) {
                        $json[i] = $json[i].toDate();
                    }
                    const date: Date = $json[i];
                    const value = `${date.getFullYear()}-${leadingZeros(
                        date.getMonth() + 1,
                        2
                    )}-${leadingZeros(date.getDate(), 2)}T${leadingZeros(
                        date.getHours(),
                        2
                    )}:${leadingZeros(date.getMinutes(), 2)}:${leadingZeros(
                        date.getSeconds(),
                        2
                    )}`;
                    t0.push(
                        ($prefix ? $prefix + '.' : '') +
                        i +
                        '=' +
                        (typeof $json[i] !== 'undefined' &&
                            $json[i] !== null
                            ? value // encodeURIComponent(value)
                            : '')
                    );
                } else if (isObject($json[i])) {
                    const data: string = $json[i].toString();
                    if (data !== '[object Object]') {
                        t0.push(
                            ($prefix ? $prefix + '.' : '') +
                            i +
                            '=' +
                            (typeof $json[i] !== 'undefined' &&
                                $json[i] !== null
                                ? encodeURIComponent($json[i])
                                : '')
                        );
                    }
                    t0.concat(
                        visit($json[i], t0, ($prefix ? $prefix + '.' : '') + i)
                    );
                } else {
                    t0.push(
                        ($prefix ? $prefix + '.' : '') +
                        i +
                        '=' +
                        (typeof $json[i] !== 'undefined' &&
                            $json[i] !== null
                            ? encodeURIComponent($json[i])
                            : '')
                    );
                }
            }
            return t0;
        };

        const result = visit(json);

        return result.length === 0 ? json : result.join('&');
    }

    protected aspMvcParser(value: any): any {
        const result: any = {};
        const buildResult = (object: any, prefix: string) => {
            for (const key in object) {
                if (object.hasOwnProperty(key)) {
                    const postKey = isFinite(parseInt(key, 10))
                        ? (prefix !== '' ? prefix : '') + '[' + key + ']'
                        : (prefix !== '' ? prefix + '.' : '') + key;
                    switch (typeof object[key]) {
                        case 'number':
                        case 'string':
                        case 'boolean':
                            result[postKey] = object[key];
                            break;
                        case 'object':
                            if (
                                object[key] == null ||
                                object[key] === undefined
                            ) {
                                result[postKey] = null;
                            } else if (object[key].toUTCstring) {
                                result[postKey] = object[key]
                                    .toUTCstring()
                                    .replace('UTC', 'GMT');
                            } else {
                                buildResult(
                                    object[key],
                                    postKey !== '' ? postKey : key
                                );
                            }
                            break;
                    }
                }
            }
        };
        buildResult(value, '');
        return result;
    }

    protected process(response: any): any;
    protected process(response: ApiResult<any>): ApiResult<any> {
        const cleanResponseValues = (value: any): any | ApiResult<any> => {
            const dateExp = /^\/Date\(\d*\)\/$/i;
            const dateWithUtc = /^\/Date\(\d*[\+\-]\d*\)\/$/i;
            const cleanApiResult = (object: any): any => {
                for (const key in object) {
                    if (object.hasOwnProperty(key)) {
                        switch (typeof object[key]) {
                            case 'string':
                                if (dateExp.test(object[key])) {
                                    let date: Date = new Date(
                                        parseInt(
                                            object[key]
                                                .replace('/Date(', '')
                                                .replace(')/', ''),
                                            10
                                        )
                                    );

                                    date = new Date(
                                        date.getTime() +
                                        date.getTimezoneOffset() * 60000
                                    );
                                    object[key] = date;
                                } else if (dateWithUtc.test(object[key])) {
                                    object[key] = new Date(
                                        parseInt(
                                            object[key]
                                                .replace('/Date(', '')
                                                .replace(/[\+\-]\d*\)\/$/i, ''),
                                            10
                                        )
                                    );
                                }
                                break;

                            case 'number':
                            case 'boolean':
                                break;

                            case 'object':
                                cleanApiResult(object[key]);
                                break;
                        }
                    }
                }
            };
            cleanApiResult(value);
            return value;
        };
        return cleanResponseValues(response);
    }


    protected buildOptionsBlob(contentType: string = 'application/json'): {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType: 'blob';
        withCredentials?: boolean;
    } {
        const headers = {
            'content-type': contentType ? contentType : 'application/json',
        };

        // if (DataRepository.token != null) {
        //   headers['Authorization'] = DataRepository.token.token;
        // }

        return {
            headers, responseType: 'blob'
        };
    }

    protected buildOptions(contentType: string = 'application/json'): {
        headers?:
        | HttpHeaders
        | {
            [header: string]: string | string[];
        };
        observe?: 'body';
        params?:
        | HttpParams
        | {
            [param: string]: string | string[];
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    } {
        const headers = {
            'content-type': contentType ? contentType : 'application/json',
        };

        // if (DataRepository.token != null) {
        //   headers['Authorization'] = DataRepository.token.token;
        // }

        return {
            headers
        };
    }

    protected buildBaseApiCall(api?: string): string {
        if (!api) {
            api = this.api;
        }

        if (___baseUrl) {
            if (___baseUrl.endsWith('/') || api.startsWith('/')) {
                if (___baseUrl.endsWith('/') && api.startsWith('/')) {
                    return ___baseUrl.substring(0, ___baseUrl.length - 1) + api;
                } else {
                    return ___baseUrl + api;
                }
            } else {
                return `${___baseUrl}/${api}`;
            }
        } else {
            return api;
        }
    }

    protected buildApiCall(relative: string = ''): string {
        const basePath: string = this.buildBaseApiCall();

        if (relative.startsWith('/') || basePath.endsWith('/')) {
            if (relative.startsWith('/') && basePath.endsWith('/')) {
                return basePath.substring(0, basePath.length - 1) + relative;
            } else {
                return basePath + relative;
            }
        }

        return `${basePath}/${relative}`;
    }
}
